/** 卸下 index.html 内联开机屏（React 首帧后再淡出） */
export function dismissBootSplash(): void {
  const el = document.getElementById('app-boot-splash');
  if (!el) return;

  const remove = () => {
    el.remove();
  };

  el.classList.add('is-leaving');
  window.setTimeout(remove, 480);
}
